// extracted by mini-css-extract-plugin
export var addressFields = "_k1-0";
export var animationContainer = "_k1-1";
export var footer = "_k1-2";
export var lineItems = "_k1-3";
export var modalContent = "_k1-4";
export var orderName = "_k1-5";
export var strong = "_k1-6";
export var warning = "_k1-7";